import { render, staticRenderFns } from "./TreeParent.vue?vue&type=template&id=22aa0900&scoped=true&"
import script from "./TreeParent.vue?vue&type=script&lang=js&"
export * from "./TreeParent.vue?vue&type=script&lang=js&"
import style0 from "./TreeParent.vue?vue&type=style&index=0&id=22aa0900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa0900",
  null
  
)

export default component.exports